export function getAuthRedirectDestination(location) {
  if (!location) {
    return null;
  }

  const searchParams = new URLSearchParams(location.search || "");
  const redirectParam = searchParams.get("redirect") || searchParams.get("returnUrl");

  if (redirectParam) {
    return redirectParam;
  }

  if (location.state?.from) {
    return location.state.from;
  }

  if (location.pathname === "/signup") {
    return "/home";
  }
  return null;
}

export function handleAuthSuccessRedirect(navigate, location) {
  const destination = getAuthRedirectDestination(location);
  if (destination) {
    navigate(destination);
  }
}
